module.exports = __webpack_public_path__ + "img/nav-left.7a8e19f6.png";